<app-image-video-texte 
*ngIf="DynamicsBCTitres!== undefined && DynamicsBC!==undefined" 
[STitleSR]="DynamicsBCTitres" [SParagrapheSR]="DynamicsBC" [height]="height" [hr]="true"  [IsFrench]="isFrench" [width]="Width"></app-image-video-texte>